import React from 'react';

function Test1() {
  return <p>This is from Test 1</p>;
}

export default Test1;
